import React, {ReactElement, RefObject} from 'react';
import block from 'bem-cn-lite';

import {Scrollspy} from '@doc-tools/components';
import {HEADER_HEIGHT} from '../../constants';
import withRouter, {WithRouterProps} from 'hoc/withRouter';

import './StickyMenu.scss';

const b = block('StickyMenu');

export enum MenuType {
    Vertical = 'vertical',
    Horizontal = 'horizontal',
}

export interface MenuItem {
    text: string | ReactElement;
    url: string;
}

export enum MenuSubtype {
    Services = 'services',
}

export interface StickyMenuProps extends WithRouterProps {
    items: MenuItem[];
    type: string;
    subtype?: MenuSubtype;
    title?: string;
    className?: string;
    menuRef?: RefObject<HTMLDivElement> | null;
    onSectionClick?: (event: MouseEvent) => void;
    scrollToListItem?: boolean;
}

const StickyMenu: React.FC<StickyMenuProps> = ({
    items,
    type,
    subtype,
    className,
    menuRef,
    router,
    onSectionClick,
    children,
    scrollToListItem,
    title,
}) => {
    const hashedLinks = items.map((link) => ({...link, url: `#${link.url}`}));

    return (
        <menu className={b({type, subtype}, className)}>
            <div ref={menuRef} className={b('wrapper')}>
                {title && <h5 className={b('title')}>{title}</h5>}
                <Scrollspy
                    className={b('sections')}
                    currentClassName={b('section', {active: true})}
                    items={hashedLinks.map(({url}) => url)}
                    headerHeight={type === MenuType.Horizontal ? HEADER_HEIGHT * 2 : HEADER_HEIGHT}
                    router={router}
                    scrollToListItem={scrollToListItem}
                    onSectionClick={onSectionClick}
                >
                    {hashedLinks.map(({text, url}) => {
                        return (
                            <li key={url} data-hash={url} className={b('section')}>
                                <a href={url} className={b('section-link')} data-router-shallow>
                                    {text}
                                </a>
                            </li>
                        );
                    })}
                </Scrollspy>
                {children}
            </div>
        </menu>
    );
};

export default withRouter(StickyMenu);
